import React from 'react';
import './scss/main-nav.scss';
import Navbar from 'react-bootstrap/Navbar';
import {Container, Form, FormControl, Nav, NavDropdown} from 'react-bootstrap';
import logo from '../assets/images/logo.png';
import MyAccountWidget from './myaccount-widget';

function MainNav(): React.ReactElement {
    const [searchText, setSearchText] = React.useState('');

    const handleSearchSubmit = (e: any) => {
        e.preventDefault();
        window.location.href = `/contract?hash=${searchText}`;
    };

    return (
        <Navbar bg="light" expand="md">
            <Container fluid>
                <Navbar.Brand href="/">
                    <img
                        src={logo}
                        height="36"
                        className="d-inline-block align-top"
                        alt="EDS NFT"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavDropdown title="Explore" id="explore-nav-dropdown">
                            <NavDropdown.Item href="/collections">Collections</NavDropdown.Item>
                            <NavDropdown.Item href="/transactions">Transactions</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Jetski" id="jetski-nav-dropdown">
                            <NavDropdown.Item href="/processes/all">Processes</NavDropdown.Item>
                            <NavDropdown.Item href="/contracts/status">Status</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Withdraw/Deposit" id="wd-nav-dropdown">
                            <NavDropdown.Item href="/withdraw">Withdraws</NavDropdown.Item>
                            <NavDropdown.Item href="/deposit">Deposits</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Manage" id="wd-nav-dropdown">
                            <NavDropdown.Item href="/asset">Asset</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown title="Diagnostics" id="wd-nav-dropdown">
                            <NavDropdown.Item href="/diagnose/cards">User Cards</NavDropdown.Item>
                            <NavDropdown.Item href="/diagnose/assets">Assets</NavDropdown.Item>
                            <NavDropdown.Item href="/diagnose/token">Token Bindings</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link href="/datagraph">Data Graph</Nav.Link>
                    </Nav>
                    <Form onSubmit={handleSearchSubmit} className="d-flex">
                        <FormControl
                            type="search"
                            placeholder="Contract Hash"
                            className="me-2"
                            style={{minWidth: '100px', maxWidth: "180px"}}
                            aria-label="Search"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button type="submit" className="btn btn-light me-2"
                                style={{width: '70px', border: '1px solid #000'}}>Search
                        </button>
                    </Form>
                    <MyAccountWidget/>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MainNav;
